import { render, staticRenderFns } from "./AccountInvoice.vue?vue&type=template&id=2f6f82ae&"
import script from "./AccountInvoice.vue?vue&type=script&lang=js&"
export * from "./AccountInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QTd,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTr,QTh,QTd,QBtn})
